<template>
  <div class="treemenu-container">
    <div class="filter-container">
      <el-input v-perm="['/sys/menu/view']" v-model="filterText" placeholder="输入菜单名过滤" size="small" style="width: 200px;" class="filter-item" />
      <el-button v-perm="['/sys/menu/add']" class="filter-item" style="margin-left: 10px;" type="primary" size="mini" icon="el-icon-plus" @click="handleCreate">添加</el-button>
    </div>
    <el-table ref="TreeTable" :data="tableData" row-key="mid" highlight-current-row stripe>
      <el-table-column prop="title" label="菜单名称" align="left" min-width="120" />
      <el-table-column prop="mid" label="菜单ID" align="center" />
      <el-table-column prop="path" label="菜单路由" align="center" />
      <el-table-column prop="name" label="路由别名" align="center" />
      <el-table-column prop="icon" label="图标" align="center">
        <template slot-scope="scope">
          <i :class="scope.row.icon"></i>
        </template>
      </el-table-column>
      <el-table-column prop="mtype" label="类型" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.mtype === 0" size="small">目录</el-tag>
          <el-tag v-else-if="scope.row.mtype === 1" size="small" type="success">菜单</el-tag>
          <el-tag v-else-if="scope.row.mtype === 2" size="small" type="info">功能</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="component" label="组件" align="center" />
      <el-table-column prop="redirect" label="重定向" align="center" />
      <el-table-column prop="listorder" label="排序" align="center" />

      <el-table-column prop="operation" label="操作" align="center" min-width="180" fixed="right">
        <template slot-scope="scope">
          <el-button v-perm="['/sys/menu/edit']" :size="btnsize" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button v-perm="['/sys/menu/del']" :size="btnsize" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="46%">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="" label-width="90px" style="width: 420px; margin-left:50px;">
        <el-form-item label="菜单类型" prop="mtype">
          <el-radio-group v-model="temp.mtype">
            <el-radio v-for="(type, index) in menuTypeList" :label="index" :key="index">{{ type }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="menuTypeList[temp.mtype] + '名称'" prop="title">
          <el-input v-model.trim="temp.title" :placeholder="menuTypeList[temp.mtype] + '名称'" size="small" />
        </el-form-item>
        <el-form-item label="上级菜单">
          <treeselect
            v-model="temp.parent_id"
            :multiple="false"
            :clearable="false"
            :disable-branch-nodes="false"
            :show-count="true"
            :normalizer="normalizer"
            :options="TreeSelectOptions"
            placeholder="请选择上级菜单..."
          />
        </el-form-item>
        <el-form-item label="路由" prop="path">
          <el-input v-model.trim="temp.path" :placeholder="menuTypeList[temp.mtype] + '路由, 例 /sys, /sys/menu'" size="small" />
        </el-form-item>
        <el-form-item v-if="temp.mtype !== 2" label="路由别名" prop="name">
          <el-input v-model.trim="temp.name" placeholder="路由别名" size="small" />
        </el-form-item>
        <el-form-item v-if="temp.mtype !== 2" label="组件" prop="component">
          <!-- <el-input v-model.trim="temp.component" placeholder="如 User/User,如有下级，则为Layout" size="small" /> -->
          <el-input v-model.trim="temp.component" :placeholder="menuTypeList[temp.mtype] + '组件, 当为目录时，且有下级时 为Layout'" size="small" />
        </el-form-item>
        <el-form-item v-if="temp.mtype !== 2" label="重定向URL">
          <el-input v-model.trim="temp.redirect" placeholder="组件重定向,例 /sys/menu, 可留空" size="small" />
        </el-form-item>
        <el-form-item v-if="temp.mtype !== 2" label="图标">
          <el-input v-model.trim="temp.icon" size="small" placeholder="图标管理里复制名称, 例 email">
            <i slot="suffix" class="el-input__icon el-icon-eye">
              <i :class="temp.icon"></i>
            </i>
          </el-input>
        </el-form-item>
        <el-form-item label="排序ID">
          <!-- onkeypress 防止录入e 及其他字符 -->
          <el-input-number v-model.trim="temp.listorder" :min="0" size="small" controls-position="left" onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="dialogStatus === 'create' ? createData() : updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import perm from "@/directive/permission/index.js" // 权限判断指令

import { createMenu, updateMenu, deleteMenu, getTreeOptions, getMenuTree } from "@/api/menu"

// import the component
import Treeselect from "@riophae/vue-treeselect"
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

export default {
  name: "sysTreeMenu",
  // 所以在编写路由 router 和路由对应的 view component 的时候一定要确保 两者的 name 是完全一致的。
  // register the component Treeselect, TreeTable
  components: { Treeselect },
  directives: { perm },
  filters: {},
  data() {
    return {
      path: this.$route.path,
      params: this.$route.params,
      filterText: "",
      btnsize: "mini",
      tableData: [],
      tableDatax: [],
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "新增"
      },
      menuTypeList: ["目录", "菜单", "功能"],
      temp: {
        mid: undefined,
        path: "",
        name: "",
        title: "",
        icon: "",
        mtype: 1,
        parent_id: 0,
        component: "",
        redirect: "",
        listorder: 99
      },
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        path: [{ required: true, message: "请输入api对应的url", trigger: "blur" }],
        name: [{ required: true, message: "请输入唯一路由别名", trigger: "blur" }],
        component: [{ required: true, message: "请输入组件url", trigger: "blur" }]
      },
      // define treeselect options
      TreeSelectOptions: [],
      // 自定义treeselect key id,label
      normalizer(node) {
        return {
          id: node.mid,
          label: node.title,
          children: node.children
        }
      }
    }
  },
  watch: {
    filterText(val) {
      if (!val) {
        //  为空 重置初始值
        this.tableData = this.tableDatax
      } else {
        this.tableData = this.filterData(this.tableData, item => {
          return item.title.includes(val)
        })
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 递归过滤树形数据
    filterData(data, predicate) {
      // if no data is sent in, return null, otherwise transform the data
      return !data
        ? null
        : data.reduce((list, entry) => {
            let clone = null
            if (predicate(entry)) {
              // if the object matches the filter, clone it as it is
              clone = Object.assign({}, entry)
            } else if (entry.children != null) {
              // if the object has childrens, filter the list of children
              const children = this.filterData(entry.children, predicate)
              if (children.length > 0) {
                // if any of the children matches, clone the parent object, overwrite
                // the children list with the filtered list
                clone = Object.assign({}, entry, { children: children })
              }
            }
            // if there's a cloned object, push it to the output list
            clone && list.push(clone)
            return list
          }, [])
    },
    getData() {
      //不需要存储信息在store中，故直接调用
      getMenuTree().then(res => {
        //console.log("getMenuTree", res)
        this.tableData = res.data
        this.tableDatax = res.data
      })
      getTreeOptions().then(res => {
        //console.log("getMenuTree", res)
        this.TreeSelectOptions = res.data
      })
    },
    resetTemp() {
      this.temp = {
        mid: undefined,
        path: "",
        name: "",
        title: "",
        icon: "",
        mtype: 1,
        parent_id: 0,
        component: "",
        redirect: "",
        listorder: 99
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = "create"
      this.dialogFormVisible = true
      this.$nextTick(() => {
        //nextTick里面的代码会在DOM更新后执行,vue数据变化是在主线程，视图更新是在异步队列中
        this.$refs["dataForm"].clearValidate()
      })
    },
    createData() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          // 处理路由别名生成唯一 /sys/menu
          //this.temp.name = this.stringToCamel(this.temp.path)

          // 调用api创建数据入库
          createMenu(this.temp).then(res => {
            // 成功后 关闭窗口
            //console.log("createMenu...", res)
            this.getData()
            this.dialogFormVisible = false
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = "update"
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate()
      })
    },
    updateData() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          // const tempData = Object.assign({}, this.temp)
          // TODO: 处理 Uncaught TypeError: Converting circular structure to JSON 问题
          const tempData = {
            mid: this.temp.mid,
            path: this.temp.path,
            name: this.temp.name,
            title: this.temp.title,
            icon: this.temp.icon,
            mtype: this.temp.mtype,
            parent_id: this.temp.parent_id,
            component: this.temp.component,
            redirect: this.temp.redirect,
            listorder: this.temp.listorder
          }
          //console.log(tempData)
          // TODO: 增加校验 rules:
          if (tempData.parent_id === tempData.mid) {
            this.$notify({
              title: "错误",
              message: "上级菜单不能选择自身",
              type: "error",
              duration: 2000
            })
            return
          }
          // console.log(this.temp)
          // 调用api编辑数据入库
          updateMenu(tempData).then(res => {
            if (res.type === "success") {
              // 后台重新更新数据
              this.getData()
              // this.$refs.TreeTable.updateTreeNode(this.temp) // 只能更新自身以下的节点
              this.dialogFormVisible = false
            }
            this.$notify({
              //  title: '错误',
              message: res.message,
              type: res.type
            })
          })
        }
      })
    },
    handleDelete(row) {
      // this.$refs.TreeTable.delete(row)
      this.$confirm("确认删除选中记录吗? [名称: " + row.title + "]", "提示", {
        type: "warning"
      }).then(() => {
        //如果存在子节点，则不能删除，但这只是在前端做了限制，后端一定要再次验证
        if (row.children) {
          this.$notify({
            //  title: '错误',
            message: row.title + " - 存在子节点不能删除",
            type: "error"
          })
          return
        }
        const delData = {
          mid: row.mid,
          title: row.title
        }
        // 调用api删除数据
        deleteMenu(delData).then(res => {
          // 如果删除成功，后台重新更新数据,否则不更新数据
          if (res.type === "success") {
            this.getData()
          }
          this.$notify({
            //  title: '错误',
            message: res.message,
            type: res.type
          })
        })
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.treemenu-container {
  margin-top: 30px;
  .filter-container {
    margin-bottom: 30px;
  }

  ::v-deep .vue-treeselect__single-value {
    line-height: 40px;
  }
}
</style>
